import { render, staticRenderFns } from "./MatchGameComponent.vue?vue&type=template&id=19687bc7&"
import script from "./MatchGameComponent.vue?vue&type=script&lang=js&"
export * from "./MatchGameComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports